import { UnitConversionFn } from "@src/shared/hooks/useUnitConversion";
import { BatchSelectionRow } from "../types";

export function buildInput(
  row: BatchSelectionRow,
  convertToInternationalUnit: UnitConversionFn,
) {
  return {
    dp: convertToInternationalUnit(
      row.dp ? parseFloat(row.dp) : 0,
      "PHYS_DIFFPRESS",
    ),
    flow: convertToInternationalUnit(
      row.flow ? parseFloat(row.flow) : 0,
      "PHYS_FLOW",
    ),
    pipeSize: row.pipeSize ?? null,
    rowId: row.id,
  };
}
